<template>
  <v-responsive aspect-ratio="1">
    <v-card
      outlined
      class="fill-height d-flex flex-column"
      @click="onClick"
      @contextmenu="show"
      @blur="onBlur"
    >
      <div class="flex-grow-1 justify-center align-center d-flex">
        <v-icon size="48" :color="addressColor">
          {{ addressIcon }}
        </v-icon>
      </div>
      <v-divider />
      <v-card-text class="py-2">
        <div class="text-truncate">
          {{ address.name }}
        </div>
      </v-card-text>
      <CloudItemMenu
        v-model="showMenu"
        :x="x"
        :y="y"
        :address="address"
        @delete-address="$emit('delete-address', $event)"
      />
    </v-card>
  </v-responsive>
</template>
<script>
import CloudItemMenu from "./CloudItemMenu.vue";
export default {
  components: { CloudItemMenu },
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  computed: {
    addressObject() {
      const extensions = {
        pdf: { icon: "mdi-file-pdf-box", color: "red" },
        docx: { icon: "mdi-file-word", color: "blue" },
        doc: { icon: "mdi-file-word", color: "blue" },
        pptx: { icon: "mdi-file-powerpoint", color: "red" },
        ppt: { icon: "mdi-file-powerpoint", color: "red" },
        xlsx: { icon: "mdi-file-excel", color: "green" },
        xls: { icon: "mdi-file-excel", color: "green" },
        csv: { icon: "mdi-file-excel", color: "green" },
        mp3: { icon: "mdi-music", color: "blue" },
        png: { icon: "mdi-image", color: "cyan" },
        jpg: { icon: "mdi-image", color: "cyan" },
        jpeg: { icon: "mdi-image", color: "cyan" },
        mp4: { icon: "mdi-video", color: "blue" },
        mkv: { icon: "mdi-video", color: "blue" },
        avi: { icon: "mdi-video", color: "blue" },
        mpg: { icon: "mdi-video", color: "blue" },
        mpeg: { icon: "mdi-video", color: "blue" },
      };
      return this.address.type === "FOLDER"
        ? { icon: "mdi-folder", color: "gray" }
        : extensions[this.address.ext] || { icon: "mdi-file", color: "gray" };
    },
    addressIcon() {
      return this.addressObject.icon;
    },
    addressColor() {
      return this.addressObject.color;
    },
  },
  methods: {
    onBlur() {
      setTimeout(() => {
        this.showMenu = false;
      }, 300);
    },
    show(e) {
      if (!["ADMIN", "ASSISTANT"].includes(this.$store.state.profile.role)) return;
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    onClick() {
      const address = this.address;
      if (address.type === "FOLDER") {
        this.$store.commit("cloud/setName", address.name);
        this.$router.push({
          name: "cloud-folder",
          params: {
            ...this.$route.params,
            path: (this.$route.params.path || "") + "&" + address.uuid,
          },
        });
      } else {
        const anchor = document.createElement("a");
        anchor.download = address.name;
        anchor.href = address.archive;
        anchor.target = "_blank";
        anchor.click();
        anchor.remove();
      }
    },
  },
};
</script>
